import { generateSpeleoId, getRpcPath, parseResponse, RpcLoggerFactory, SilentRequestLogger, } from '../utils';
function identityPromise(a) {
    return new Promise((resolve) => resolve(a));
}
function defaultUrlForMethod(_method, derivedUrl) {
    return derivedUrl;
}
export default function rpc(urlForMethod = defaultUrlForMethod, loggerFactory = new RpcLoggerFactory(SilentRequestLogger), errorDeserializer = identityPromise, additionalHeaders = () => new Map(), responseParser = parseResponse, sendSpeleoTraceId = false, beforeRequest, afterResponse, signal) {
    async function rpcImpl(method, requestData, callback) {
        const logger = loggerFactory.build();
        const url = urlForMethod(method, getRpcPath(method));
        const headers = {};
        headers['Accept'] = 'application/x-protobuf';
        headers['Content-Type'] = 'application/x-protobuf';
        for (const [key, value] of (additionalHeaders instanceof Function
            ? additionalHeaders()
            : additionalHeaders).entries()) {
            headers[key] = value;
        }
        if (sendSpeleoTraceId && !('X-SPELEO-TRACE-ID' in headers)) {
            headers['X-SPELEO-TRACE-ID'] = generateSpeleoId();
        }
        const fetchOptions = {
            method: 'POST',
            credentials: 'include',
            headers,
            body: requestData,
            signal,
        };
        if (beforeRequest) {
            await beforeRequest(requestData);
        }
        logger.logRequest(method, url, requestData);
        let responseData = null;
        let responseError = null;
        try {
            const response = await fetch(url, fetchOptions);
            const deserializedResponse = await errorDeserializer(response, method);
            responseData = await responseParser(deserializedResponse, method);
            logger.logResponse(method, url, responseData);
            callback(null, responseData);
        }
        catch (e) {
            const error = e;
            logger.logError(method, url, error);
            responseError = new Error(`${error.message} \n Proto: ${method.name} \n URL: ${url}`, 
            // TODO: remove \`@ts-expect-error` once jest supports ES2022
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            { cause: error });
            callback(responseError, null);
        }
        finally {
            if (afterResponse) {
                await afterResponse(responseData, responseError);
            }
        }
    }
    return rpcImpl;
}
